export const supportedLanguages = [
  'en', 'zh-CN', 'ko', 'jp', 'vi', 'hi',
  'th', 'ru', 'es', 'fr', 'de', 'it'
];

const languageKey = 'change-language';

function readCookieLanguage() {
  const match = document.cookie.match(/(?:^|;\s*)change-language=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

export function normalizeLanguage(value) {
  return supportedLanguages.includes(value) ? value : '';
}

export function getStoredLanguage() {
  const candidates = [
    localStorage.getItem(languageKey),
    sessionStorage.getItem(languageKey),
    readCookieLanguage()
  ];

  for (const value of candidates) {
    const language = normalizeLanguage(value);
    if (language) return language;
  }

  return 'en';
}

export function persistLanguage(language) {
  const value = normalizeLanguage(language) || 'en';

  localStorage.setItem(languageKey, value);
  sessionStorage.setItem(languageKey, value);
  document.cookie = `${languageKey}=${encodeURIComponent(value)}; path=/; max-age=31536000; SameSite=Lax`;
  document.documentElement.setAttribute('lang', value);

  return value;
}

